import React from "react";
import Modal from 'react-modal';
import MarketIntelligenceContent from "./MarketIntelligenceContent";
import './MarketIntelligence.scss';

const MarketIntelligenceModal = (props) => {
    const { isOpen, close, defaultPairId } = props;

    Modal.setAppElement('#root');

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={close}
            overlayClassName="ReactModal__Overlay--fullscreen"
            className="ReactModal__Content--fullscreen"
        >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div style={{ flex: 1, overflow: 'auto' }}>
                    <MarketIntelligenceContent isModal={true} close={close} defaultPairId={defaultPairId} />
                </div>
                <div className="p-4 border-top bg-white d-flex justify-content-center">
                    <button className="subscription-btn" onClick={close} style={{maxWidth: '200px'}}>Close</button>
                </div>
            </div>
        </Modal>
    );
};

export default MarketIntelligenceModal;
